// extracted by css-extract-rspack-plugin
export default {"danger":"danger-10es4"};